$(document).ready(function() {
    section2();
    section3();
    section4();
    reload6()
    section6();

    /* 5 ----------------------------------------- */

    let owl_5 = $("#about-section-5 .owl-carousel").owlCarousel({
        items: 3,
        nav: false,
        dots: false,
        margin: 20,
        stagePadding: 50,
        smartSpeed: 800,
        responsive: {
            0 : {
                items: 1,
                margin: 15,
                stagePadding: 30,
            },
            375 : {
                items: 1,
                margin: 15,
                stagePadding: 30,
            },
            390 : {
                items: 1,
                margin: 15,
                stagePadding: 30,
            },
            414 : {
                items: 1,
                margin: 15,
                stagePadding: 30,
            },
            428 : {
                items: 1,
                margin: 15,
                stagePadding: 30,
            },
            480 : {
                items: 1,
                margin: 15,
                stagePadding: 40,
            },
            768 : {
                items: 2,
                margin: 20,
                stagePadding: 40,
            },
            800 : {
                items: 2,
                margin: 20,
                stagePadding: 40,
            },
            1024 : {
                items: 2,
                margin: 20,
                stagePadding: 40,
            },
            1280 : {
                items: 3,
                margin: 20,
                stagePadding: 20,
            },
            1366 : {
                items: 3,
                margin: 20,
                stagePadding: 20,
            },
            1440 : {
                items: 3,
                margin: 20,
                stagePadding: 30,
            },
            1536 : {
                items: 3,
                margin: 20,
                stagePadding: 40,
            },
            1600 : {
                items: 3,
                margin: 20,
                stagePadding: 40,
            },
            1920 : {
                items: 3,
                margin: 20,
                stagePadding: 50,
            },
            2560 : {
                items: 3,
                margin: 20,
                stagePadding: 50,
            }
        }
    });

    /* 6 ----------------------------------------- */

    let owl_6 = $("#about-section-6 .owl-carousel").owlCarousel({
        items: 1,
        nav: true,
        dots: false,
        loop: true,
        margin: 50,
        smartSpeed: 800,
        autoHeight: true,
        navText: ['<i class="fa-solid fa-chevron-left"></i>', '<i class="fa-solid fa-chevron-right"></i>'],
        responsive: {
            0: {
                margin: 50
            },
            768: {
                margin: 100
            }
        }
    });

});

$(window).scroll(function() {
    section2();
    section3();
    section4();
    section6();
});

$(window).resize(function() {
    reload6();
});


function section2() {
    $section2 = $('#about-section-2 .desktop .data-row');
    $section2.each(function() {
        if (visiblePercent($(this)) > 10) {
            if (!$(this).find('.aos-init').hasClass('aos-animate')) {
                $(this).find('.aos-init').addClass('aos-animate');
            }
        }
        else {
            if ($(this).find('.aos-init').hasClass('aos-animate')) {
                $(this).find('.aos-init').removeClass('aos-animate');
            }
        }
    });

    $section2_m = $('#about-section-2 .mobile');
    $section2_m.each(function() {
        if (visiblePercent($(this)) > 10) {
            if (!$(this).find('.aos-init').hasClass('aos-animate')) {
                $(this).find('.aos-init').addClass('aos-animate');
            }
        }
        else {
            if ($(this).find('.aos-init').hasClass('aos-animate')) {
                $(this).find('.aos-init').removeClass('aos-animate');
            }
        }
    });
}

function section3() {
    $section3 = $('#about-section-3 .aos-init');
    $section3.each(function() {
        if (visiblePercent($(this)) > 10) {
            if (!$(this).hasClass('aos-animate')) {
                $(this).addClass('aos-animate');
            }
        }
        else {
            if ($(this).hasClass('aos-animate')) {
                $(this).removeClass('aos-animate');
            }
        }
    });
}

function section4() {
    $section4 = $('#about-section-4 .desktop .data-row');
    $section4.each(function() {
        if (visiblePercent($(this)) > 10) {
            if (!$(this).find('.aos-init').hasClass('aos-animate')) {
                $(this).find('.aos-init').addClass('aos-animate');
            }
        }
        else {
            if ($(this).find('.aos-init').hasClass('aos-animate')) {
                $(this).find('.aos-init').removeClass('aos-animate');
            }
        }
    });

    $section4_m = $('#about-section-4 .mobile');
    $section4_m.each(function() {
        if (visiblePercent($(this)) > 10) {
            if (!$(this).find('.aos-init').hasClass('aos-animate')) {
                $(this).find('.aos-init').addClass('aos-animate');
            }
        }
        else {
            if ($(this).find('.aos-init').hasClass('aos-animate')) {
                $(this).find('.aos-init').removeClass('aos-animate');
            }
        }
    });
}

function reload6() {

    let aHeight = 0;
        if (!announcement_isClosed)
            aHeight = announcement_height;
    let hHeight = $('#header').height();
    $('#about-section-6 .sticky').css('top', `${(aHeight+hHeight)-2}px`);

    $('#about-section-6 .milestones .content').each(function(index, element){
        let contentHeight = $(this).height();
        let correspondingDots = $('#about-section-6 .dots').eq(index);
        correspondingDots.height(contentHeight)
    });

    let firstDotOffset = $('#about-section-6 .dots .dot').eq(0).offset();
    let lastDotOffset = $('#about-section-6 .dots .dot').eq(-1).offset();
    let distance = Math.abs(firstDotOffset.top - lastDotOffset.top);
    
    $('#about-section-6 .hozline').css('height', `${distance}px`);
    
    let dot = $('#about-section-6 .dots .dot').height();

    $('#about-section-6 .hozline').css('top', `calc(50% + ${dot/1.5}px)`);
}

function section6() {
    $section6 = $('#about-section-6 .milestones .data');
    $section6.each(function() {
        if (visiblePercent($(this)) == 100) {
            if (!$(this).hasClass('active')) {
                $(this).addClass('active');
            }
        }
        else {
            if ($(this).hasClass('active')) {
                $(this).removeClass('active');
            }
        }
    });
}

$('#announcement-bar .announcement-close').on('click', function() {
    let hHeight = $('#header').height();
    $('#about-section-6 .sticky').css('top', `${(hHeight)-2}px`);
});